import React from "react";
import { withTranslation } from 'react-i18next';
import { AddOnsService } from "./addOnsSevice";

class AddOnsServiceParent extends React.Component {
  constructor(props) {
    super(props);
    this.state = {

    }
  }
  render() {
    return <AddOnsService {...this?.props}/>;
  }
}

export default withTranslation('addons')(AddOnsServiceParent);
